<template>
  <v-card>
    <v-card-title class="headline py-2">
      Экспортировать данные
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container grid-list-lg class="pa-0">
        <v-layout row wrap>
          <v-flex xs12>
            <p class="subheading">Выберите какие объекты учета нужно экспортировать</p>
            <v-data-table id="statistic-export-table" v-model="selectedObjects" :headers="headers" :items="tableObjects" item-key="id" select-all hide-actions>
              <template v-slot:items="props">
                <td><v-checkbox v-model="props.selected" color="primary" hide-details></v-checkbox></td>
                <td>{{ props.item.name }}</td>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs6>
            <DatetimePicker clearable v-model="dateFrom" label="Начальный период" :scrollable="false" format="YYYY-MM-DD HH:mm:ss"></DatetimePicker>
          </v-flex>
          <v-flex xs6>
            <DatetimePicker clearable v-model="dateTo" label="Конечный период" :scrollable="false" format="YYYY-MM-DD HH:mm:ss"></DatetimePicker>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled || selectedObjects.length===0">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  import DatetimePicker from '@/components/DatetimePicker'
  
  export default {
    name : "ExportForm",
  
    components: {
      DatetimePicker,
    },
    
    props : {
      id: {
        type: String,
        required: true,
      },
      lines:{
        type: Array,
        required: false,
        default: () => []
      }
    },
  
    created(){
      this.tableObjects = this.lines.map( item  => {
        item.id = item.value.join(',')
        let name = item.text.replace(/\n/g, "->")
        return {
          name: name,
          properties_ids: item.value,
          id: item.id
        }
      })
    },
    
    data() {
      return {
        status : {
          btnDisabled : false,
          text : '',
          className : 'success--text darken-1'
        },
        headers: [ { text: 'Объект учета', sortable: false, value: 'name' } ],
        selectedObjects: [],
        tableObjects : [],
        dateFrom: null,
        dateTo: null
      }
    },
    
    methods : {
      submit() {
        this.status = { btnDisabled : true, text : 'Сохранение', className : 'secondary--text lighten-1' }
        let data = {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          objects: this.selectedObjects,
          label_id: this.id,
          timezone: this.$store.getters['app/account/accountTimeZone'] || null
        }
        this.$store.dispatch( 'analytics_old/indicators/exportLabel', data ).then( token => {
          this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
          let url = '/api/public/analytics/v1/download/'+token
          let anchor = document.createElement('a');
          anchor.href = url;
          anchor.target = '_blank';
          anchor.download = 'export';
          anchor.click();
          this.$emit( 'close-dialog' )
        }).catch( error => {
          this.status = { btnDisabled : false, text : 'Ошибка', className : 'error--text darken-1' }
        })
      }
    }
    
  }
</script>

<style>
  #statistic-export-table td, #statistic-export-table th{
    padding: 3px 5px;
    height: auto;
  }
  #statistic-export-table thead tr {
    height: inherit;
  }
</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/Forms/ExportForm.vue